import React from "react";
import clsx from "clsx";

const classesByVariant = {
  success: "bg-emerald-100 text-emerald-800",
  warning: "bg-amber-100 text-amber-800",
  danger: "bg-rose-100 text-rose-800",
  info: "bg-indigo-100 text-indigo-800",
  muted: "bg-slate-200 text-slate-700"
};

export default function StatusPill({
  active,
  label,
  variant = "info",
  labelActive = "Ativo",
  labelInactive = "Inativo",
  customColorActive = "bg-green-50 text-green-700 ring-green-600/20",
  customColorInactive = "bg-gray-50 text-gray-600 ring-gray-500/10"
}) {
  if (typeof active === "boolean") {
    return (
      <span
        className={clsx(
          "inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset",
          active ? customColorActive : customColorInactive
        )}
      >
        {active ? labelActive : labelInactive}
      </span>
    );
  }

  return (
    <span
      className={clsx(
        "inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold",
        classesByVariant[variant] || classesByVariant.info
      )}
    >
      {label || labelInactive}
    </span>
  );
}

